<template>
  <div style="height: 650px">
    <div>
    <el-input v-model="this.query.original_name" placeholder="图片名称" style="width:150px; margin: 5px"/>
      <el-button type="primary" @click="getPictureItems">搜索</el-button>
    </div>
  <el-table :data="tableData" v-loading="tableLoad" height="600" border style="width: 100%">
    <el-table-column prop="originalName" label="图片名称" width="310" align="center">
    </el-table-column>
    <el-table-column prop="url" label="图片" width="550" align="center">
      <template #default="scope">
        <el-image :preview-src-list="pictures" @click="this.pictures[0] = scope.row.url" style="width: 200px; height: 100px" :src="scope.row.url"></el-image>
      </template>
    </el-table-column>
    <el-table-column label="操作" width="100" align="center">
      <template #default="scope">
        <el-button @click="deletePicture(scope.row.id)" type="primary">删除</el-button>
      </template>
    </el-table-column>
  </el-table>
  </div>
<!--  <div class="pageStyle">
    <el-pagination style="margin-right: 13px" background layout="total, prev, pager, next" :total="total" :current-page="query.pageNo" @current-change="currentCheckChange" :page-size="50"></el-pagination>
  </div>-->
</template>

<script>
export default {
  name: "PictureItem",
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data(){
    return{
      tableData:[],
      pictures:[],
      query:{
        pageNo:1,
        original_name:'',
      },
      tableLoad:false,
      total:0
    }
  },
  methods:{

    /*currentCheckChange(pageNo){
      this.query.pageNo=pageNo
      this.getPictureItems()
    },*/

    async deletePicture(id){
      this.tableLoad = true
      let query = {
        fileId:id,
        pictureId:this.parentData.id
      }
      let {data: res} = await this.$axios.post('bus/picture/deletePictureItem',query);
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.tableLoad = false
      }else {
        this.$message.success('删除成功')
        await this.getPictureItems()
      }
    },

    searchByQuery(){
      let time
      clearTimeout(time)
      time = setTimeout(()=>{
        this.getPictureItems()
      },1000)
    },

    async getPictureItems() {
      this.tableLoad = true
      this.query.pictureId = this.parentData.id
      let {data: res} = await this.$axios.post('bus/picture/getPictureItems',this.query);
      if (res.code !== 0) {
        this.$message.error('获取【图片明细】失败')
      }
      this.tableData = res.data
      this.tableLoad = false
    }

  },

  created() {
    this.getPictureItems()
  }

}
</script>

<style scoped>
.pageStyle{
  width: 100%;
  display: flex;
  justify-content:flex-end;
  margin: 20px 0
}

/deep/.el-table .el-table__cell{
  z-index: auto;
}
</style>